var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTpdashboardwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4545 22H4.54545C4.24407 22 3.95503 21.882 3.74192 21.6721C3.52881 21.4621 3.40909 21.1773 3.40909 20.8803V10.8031H0L11.7352 0.291519C11.9444 0.103946 12.2171 0 12.5 0C12.7829 0 13.0556 0.103946 13.2648 0.291519L25 10.8031H21.5909V20.8803C21.5909 21.1773 21.4712 21.4621 21.2581 21.6721C21.045 21.882 20.7559 22 20.4545 22ZM5.68182 19.7606H19.3182V8.73955L12.5 2.63278L5.68182 8.73955V19.7606Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpdashboardwhite);
export default __webpack_public_path__ + "static/media/tpdashboardwhite.d3eae6450a8afbe00750ab011886a305.svg";
export { ForwardRef as ReactComponent };